import DashboardSidebar from "@/features/sidebar/components/app-sidebar";
import { Separator } from "@/common/components/ui/separator";
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/common/components/ui/sidebar";

import { Link } from "react-router-dom";
import { useAuth } from "../../auth/hooks/useAuth";
import UserProfileDropDown from "@/common/components/shared/UserProfileDropDown";

const Sidebar = ({ children }) => {
  const {
    user: { profile: currentUser },
  } = useAuth();
  return (
    <SidebarProvider className="bg-white">
      <DashboardSidebar />
      <SidebarInset className="overflow-hidden bg-white">
        <header className="sticky top-0 z-50 flex h-14 shrink-0 flex-row items-center justify-between w-full px-4 bg-white border-b border-zinc-200">
          <div className="flex items-center gap-2.5 min-w-0">
            <SidebarTrigger />
            <Separator orientation="vertical" className="h-4 bg-zinc-200" />
            <Link to="/home" className="flex min-w-0 md:w-auto">
              <span className="truncate text-[15px] font-medium tracking-tight text-zinc-800">
                {currentUser?.university?.name}
              </span>
            </Link>
          </div>
          {currentUser && (
            <div className="shrink-0">
              <UserProfileDropDown />
            </div>
          )}
        </header>
        <div className="flex flex-col flex-grow bg-white">{children}</div>
      </SidebarInset>
    </SidebarProvider>
  );
};

export default Sidebar;
